import { render } from "./Chart.vue?vue&type=template&id=4a450d8d"
import script from "./Chart.vue?vue&type=script&lang=ts"
export * from "./Chart.vue?vue&type=script&lang=ts"
script.render = render

export default script